export default {"src":"/_next/static/media/defaultCollection.4ef51694.svg","height":144,"width":144};